import Button from '@space-core/components/button'
import Modal from '@space-core/components/modal'
import ModalBody from '@space-core/components/modalBody'
import { useMediaQuery } from '@space-core/hooks'
import useTranslation from '@space-core/hooks/useTranslation'
import { customMedia, ScreenSizes } from '@space-core/styles'

import HotmartClub from '@space-shell/assets/images/hotmartClub.png'
import HotmartClubMobile from '@space-shell/assets/images/hotmartClubMobile.png'

import { useLegacyClubRedirect } from '@space-shell/common/hooks/useLegacyClubRedirect'
import useMembership from '@space-shell/common/hooks/useMembership'

import styled from 'styled-components'

const ModalContainer = styled(Modal)`
  --modal-backdrop-pointer-events: none;
  --modal-max-width: 48.75rem;
  --modal-padding: 0;
`

const LoginButton = styled(Button)`
  width: 12.5rem;

  ${customMedia.lessThan('lg')`
    width: 100%;
  `}
`

const ImageContainer = styled.div`
  @media (max-height: 37.82rem) {
    display: none;
  }
`

const LegacyClubRedirectModal = () => {
  const { t } = useTranslation()
  const { membershipData } = useMembership()
  const { isRedirectedUser, handleLoginClick } = useLegacyClubRedirect()
  const isMobile = useMediaQuery(`(max-width: ${ScreenSizes.lg})`)
  const hotmartClubImage = isMobile ? HotmartClubMobile : HotmartClub

  if (!isRedirectedUser) {
    return null
  }

  return (
    <ModalContainer show onClose={() => void 0} centered>
      <ModalBody className='_p-0 _d-flex _justify-content-between _flex-column-reverse _flex-lg-row'>
        <div className='_py-5 _py-lg-6 _px-4 _px-lg-5'>
          <p className='_text-gray-900 _m-0 _font-14'>{t('old_club_redirect.title')}</p>
          <h2 className='_mb-3 _text-3 _text-gray-900 _line-height-lg _font-weight-light'>
            <strong>{membershipData?.name}</strong>
          </h2>
          <p className='_text-gray-900 _m-0 _font-14'>
            {t('old_club_redirect.description.first_paragraph')}
          </p>
          <ul className='_my-5 _pl-5 _text-gray-900 _font-14'>
            <li>{t('old_club_redirect.description.second_paragraph')}</li>
            <li>{t('old_club_redirect.description.third_paragraph')}</li>
            <li>{t('old_club_redirect.description.fourth_paragraph')}</li>
            <li>{t('old_club_redirect.description.fifth_paragraph')}</li>
            <li>{t('old_club_redirect.description.sixth_paragraph')}</li>
          </ul>
          <LoginButton onClick={handleLoginClick} className='_mt-7' variation='info'>
            {t('old_club_redirect.text_button')}
          </LoginButton>
        </div>
        <ImageContainer className='_py-6 _px-0 _px-lg-8 _bg-gray-200 _d-flex _justify-content-center _align-items-center _overflow-hidden'>
          <img src={hotmartClubImage} alt={t('old_club_redirect.banner_alt_text')} />
        </ImageContainer>
      </ModalBody>
    </ModalContainer>
  )
}

export default LegacyClubRedirectModal
